import { getPortalId } from '../utils/getPortalId';
import { apiClientWithMiddleware } from '../utils/API';
import { dataFetchingErrorHandler } from '../errors/dataFetchingErrorHandler';
import { NAV_BOOKMARKED_ITEMS_ATTR } from '../constants/navPersona';
const navPersonaApiClient = apiClientWithMiddleware();
const URL_SLUG = `navpersona/depot/v1/attribute/`;
const GET_URL_SLUG = `/navpersona/depot/v2/portal-user-attribute`;
const setAttribute = (attributeName, value, userId) => {
  const portalId = getPortalId();
  const endpoint = userId === undefined ? `${URL_SLUG}${portalId}` : `${URL_SLUG}${portalId}/${userId}`;
  return navPersonaApiClient.post(endpoint, {
    data: {
      personaAttributeName: attributeName,
      personaAttributeValue: value
    },
    query: {
      portalId
    }
  }).catch(dataFetchingErrorHandler('Failed to set attribute on nav persona', {
    defaultResult: null
  }));
};
const getAttribute = attributeName => {
  const portalId = getPortalId();
  const endpoint = `${GET_URL_SLUG}/${attributeName}`;
  return navPersonaApiClient.get(endpoint, {
    query: {
      portalId
    }
  }).catch(dataFetchingErrorHandler('Failed to get attribute on nav persona', {
    defaultResult: null
  }));
};
const getBookmarks = async () => {
  try {
    const response = await getAttribute(NAV_BOOKMARKED_ITEMS_ATTR);
    const bookmarkData = JSON.parse((response === null || response === void 0 ? void 0 : response.personaAttributeValue) || '{}');
    return Object.values((bookmarkData === null || bookmarkData === void 0 ? void 0 : bookmarkData.entities) || {}).map(entity => ({
      path: entity === null || entity === void 0 ? void 0 : entity.path
    })).filter(bookmark => bookmark.path);
  } catch (_unused) {
    return [];
  }
};
export const navPersonaService = {
  setAttribute,
  getAttribute,
  getBookmarks
};